(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["company-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* --- Fade-in observer --- */
    var fadeEls = document.querySelectorAll('.company-timeline__fade');
    if (fadeEls.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      fadeEls.forEach(function (el, i) {
        el.style.transitionDelay = (i * 0.15) + 's';
        observer.observe(el);
      });
    }

    /* --- Clip dashed line to first/last dot --- */
    function positionLine() {
      document.querySelectorAll('.company-timeline__body').forEach(function (body) {
        var dots = body.querySelectorAll('.company-timeline__dot');
        var elements;

        /* Desktop: measure actual dot elements; Mobile: dots are hidden, measure entries */
        if (dots.length >= 2 && dots[0].offsetParent !== null) {
          elements = dots;
        } else {
          elements = body.querySelectorAll('.company-timeline__entry');
        }

        if (elements.length < 2) return;

        var bodyRect = body.getBoundingClientRect();
        var firstRect = elements[0].getBoundingClientRect();
        var lastRect = elements[elements.length - 1].getBoundingClientRect();

        var firstCenter = firstRect.top + firstRect.height / 2 - bodyRect.top;
        var lastCenter = lastRect.top + lastRect.height / 2 - bodyRect.top;

        body.style.setProperty('--ct-line-top', firstCenter + 'px');
        body.style.setProperty('--ct-line-bottom', (bodyRect.height - lastCenter) + 'px');
      });
    }

    document.fonts.ready.then(positionLine);
    window.addEventListener('resize', positionLine);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leadership-team"] && !Shopify.designMode) return;
  try {
    
  /**
   * Toggle the `is-scrolled` class on each leadership-team drawer based on
   * the body's scroll position so the photo shrinks when scrolled and
   * grows back when scrolled to the top.
   *
   * The naive add-on-down/remove-at-zero approach can flicker because
   * shrinking the photo (aspect-ratio: 1) shrinks the header, grows the
   * body, and may clamp scrollTop back to 0 — which would remove the
   * class, grow the photo, shrink the body, and start the cycle again.
   *
   * To prevent that: after every class toggle we LOCK toggling for the
   * duration of the CSS transition. Layout settles inside the lock, and
   * once the lock releases we read the body's scroll position freshly to
   * decide whether to toggle again. For drawers whose content barely
   * overflows, the photo will commit to the small state and stay there
   * (since no scroll input is possible once the body fits its content) —
   * that's the intended behavior.
   */
  (function () {
    const TRANSITION_MS = 280;

    const drawers = document.querySelectorAll('.leadership-team__drawer');
    drawers.forEach((drawer) => {
      const body = drawer.querySelector('.leadership-team__drawer-body');
      if (!body) return;

      let transitionLock = false;
      const releaseLock = () => { transitionLock = false; };

      body.addEventListener('scroll', () => {
        if (transitionLock) return;

        const scrolled = body.scrollTop > 0;
        const hasClass = drawer.classList.contains('is-scrolled');

        if (scrolled !== hasClass) {
          drawer.classList.toggle('is-scrolled', scrolled);
          transitionLock = true;
          setTimeout(releaseLock, TRANSITION_MS);
        }
      }, { passive: true });

      // Reset state when the drawer closes so the next open starts at the
      // top with the full-size photo.
      drawer.addEventListener('close', () => {
        drawer.classList.remove('is-scrolled');
        body.scrollTop = 0;
        transitionLock = false;
      });

      // Also reset on open in case the browser preserved scrollTop across
      // the close/open cycle.
      new MutationObserver(() => {
        if (drawer.hasAttribute('open')) {
          body.scrollTop = 0;
          drawer.classList.remove('is-scrolled');
          transitionLock = false;
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.social-proof').forEach(function (section) {
      var slides = section.querySelectorAll('.social-proof__slide');
      var dots = section.querySelectorAll('.social-proof__dot');
      var prevBtn = section.querySelector('.social-proof__arrow--prev');
      var nextBtn = section.querySelector('.social-proof__arrow--next');
      var total = slides.length;

      if (total <= 1) return;

      var current = 0;

      function goTo(index) {
        slides[current].classList.remove('social-proof__slide--active');
        dots[current].classList.remove('social-proof__dot--active');

        current = (index + total) % total;

        slides[current].classList.add('social-proof__slide--active');
        dots[current].classList.add('social-proof__dot--active');
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.dotIndex, 10));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
